<template>
  <div style="width: 100%">
    <highcarts :options="chartOptions" style="width: 100%" :Highcharts="$hc"></highcarts>
  </div>
</template>
<script>
  import Highcharts from 'highcharts'
  import {Chart} from 'highcharts-vue'
  import { Color } from '../../../utils/Color'

  export default {
    components: {
      'highcarts': Chart
    },
    props: {
      chartData: {
        type: Object,
        required: true,
        default: () => ({
          'actions': {},
          'categories': {},
        })
      }
    },
    mounted() {
      var dateFormat = Intl.DateTimeFormat('hu', {year: 'numeric', month: 'short'})
      var formatDate = (dateString) => dateFormat.format(Date.parse(dateString))

      this.chartOptions.xAxis[0].categories = _.map(this.chartData.categories, category => formatDate(category))

      var yAxis = 0
      var yAxisTemplate = (enabled, opposite = true) => ({ // Primary yAxis
        labels: {
          format: '{value} %',
          enabled
        },
        title: {
          text: 'Megnyitási ráta',
          enabled
        },
        opposite
      })

      var mapValues = (action) => {
        return _.map(this.chartData.categories, category => {
          if (typeof action[category] === 'undefined') {
            return null
          } else {
            return Math.ceil(parseFloat(action[category]) * 100)
          }
        })
      }

      _.forEach(this.chartData.actions, (action, name) => {
        this.chartOptions.yAxis.push(yAxisTemplate(yAxis === 0))
        var data = mapValues(action)

        this.chartOptions.series.push({
          name: `Action ${name}`,
          yAxis,
          type: 'spline',
          data,
          color: Color.action(name).toString(),
          tooltip: {
            valueSuffix: ' %'
          }
        })

        yAxis++
      })
    },
    data() {
      return {
        chartOptions: {
          chart: {
            zoomType: 'xy',
            marginBottom: 100
          },
          title: undefined,
          xAxis: [{
            categories: [],
            crosshair: true
          }],
          yAxis: [],
          tooltip: {
            shared: true
          },
          series: [],
        }
      }
    }
  }
</script>